/**
 * Created by dmarthak on 08/02/18.
 */

define(function (require, exports, module) {
    'use strict';
    // @ngInject
    exports.CommonService = function (lpPortal,lpCoreBus, lpConstants, lpCoreUtils, $q, $timeout, $window, $http, TranslateService, MobileAlertService) {
        var isMobileNative = window.cxp && window.cxp.mobile ? true : false;
        var digiPassPlugin;
        const urls = {
            logOutUrl :lpPortal.root + '/bb-public-api/security/logout',
            userStatusUrl: lpPortal.root + '/services/rest/v1/user-status'
        };

        if ($window.cxp && $window.cxp.mobile && $window.cxp.mobile.plugins) {
            digiPassPlugin = $window.cxp.mobile.plugins['DigiPass'];
        }

        function isNative() {
            return $window.cxp && $window.cxp.mobile ? true : false;
        }

        //check if user session exceeds
        function validateSession(X_BBSCCOUNT) {
            return X_BBSCCOUNT > 1;
        }
        //check if user is vasco registered
        function IsUserDigipassRegistered() {
            let deferred = $q.defer();
            if(digiPassPlugin) {
                digiPassPlugin.isDigiPassRegister(function (response) {
                    let isDigiPassRegistered = response.data || false;
                    deferred.resolve(isDigiPassRegistered);
                }, function(response){
                    let isDigiPassRegistered = response.error || false;
                    deferred.reject(isDigiPassRegistered);
                });
            }else{
                deferred.reject(false);
            }
            return deferred.promise;
        }
        //show title on the header bar
        function toggleTitlebar(showTitlebar, title) {
            showTitlebar && isMobileNative ? lpCoreBus.publish(lpConstants.PUBLISH.TOOLBAR_ENABLE, {"title": title}) : lpCoreBus.publish(lpConstants.PUBLISH.TOOLBAR_DISABLE);
        }
        //common logout
        function logout(){
            var data = {
                BBXSRF: localStorage.getItem('token'),
                portal_name: lpPortal.name,
                page_name: lpPortal.page.name
            };

            $http.post(urls.logOutUrl, lpCoreUtils.buildQueryString(data),{
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/x-www-form-urlencoded;',
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Pragma': 'no-cache',
                    'Expires': '0'
                }
            }).then(function (response) {
                clearAndSignOut();
            }, function (response) {
                clearAndSignOut();
            });
        }

        //get user status to accept terms and condition while onboarding process
        function getUserStatus() {
            return $http.get(urls.userStatusUrl);
        }

        function serverErrorAlert(callBack){
            let message = TranslateService.translate("abc.common.error.oops") + " " + TranslateService.translate("abc.common.system.down.message");
            const buttons = [{
                type: lpConstants.MOBILE_SDK_BUTTONS.POSITIVE,
                text: TranslateService.translate("abc.common.button.ok"),
                callback: callBack
            }];
            MobileAlertService.show(message, buttons);
        }

        //Private function
        function clearAndSignOut(){
            localStorage.clear();
            window.cxp && window.cxp.mobile ? lpCoreBus.publish(lpConstants.PUBLISH.SIGNOUT) : $window.location.href = lpPortal.root + '/'+lpPortal.name+'/sign-in';
        }

        function preventPageScroll(payload) {
            var overflowVal = payload ? 'hidden' : '';
            $timeout(function () {
                $('body').css('overflow', overflowVal);
            },0);
        }
        //pass country and check if this country matches with current (loggedin) country
        function isValueDateEnabled(currentCountry, allowedCountries){
            return (currentCountry && allowedCountries) ? allowedCountries.toLowerCase().trim().split(lpConstants.IGNORE_SPACE_REGEX).indexOf(currentCountry.toLowerCase()) > -1 : false;
        }

        function downloadFile (payload) {
            var linkElement = document.createElement('a');
            var fileName = payload.fileName;
            var content='data:' + payload.mimeType + ';base64,' + payload.fileData;
            linkElement.setAttribute('href', content);
            linkElement.setAttribute('download', fileName);
            // IE workaround
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                var byteCharacters = atob(payload.fileData);
                var byteNumbers = [];
                for (var i = 0; i < byteCharacters.length; i++) {
                    byteNumbers.push(byteCharacters.charCodeAt(i));
                }
                var byteArray = new Uint8Array(byteNumbers);
                var blob = new Blob([byteArray], {type: payload.mimeType+";charset=utf-8"});
                window.navigator.msSaveBlob(blob, fileName);
            }
            else
            {
                var clickEvent = new MouseEvent("click", {
                    "view": window,
                    "bubbles": true,
                    "cancelable": false
                });
                linkElement.dispatchEvent(clickEvent);
            }
        }


				function deleteText(event) {
				    if(!event || !event.target) {
				      return;
				    }
			      let element = angular.element(event.target);
			      if (element) {
	            let isFirefox = typeof InstallTrigger !== 'undefined';
	            let val = element.val();
	            if (event.keyCode == 8 && isFirefox) {
		              val = val.slice(0, val.length - 1);
		              element.val(val);
	                event.preventDefault();
	            }
            }
        }
        return {
            isNative: isNative,
            validateSession: validateSession,
            IsUserDigipassRegistered: IsUserDigipassRegistered,
            toggleTitlebar: toggleTitlebar,
            logout: logout,
            getUserStatus: getUserStatus,
            serverErrorAlert: serverErrorAlert,
            preventPageScroll: preventPageScroll,
            isValueDateEnabled: isValueDateEnabled,
            downloadFile: downloadFile,
            deleteText: deleteText
        };
    };

});



//////////////////
// WEBPACK FOOTER
// ./scripts/common-service.js
// module id = 7
// module chunks = 0